import { Capacitor } from '@capacitor/core';
import { debugLog } from '../utils/debugUtils';

class AnalyticsService {
  constructor() {
    this.initialized = false;
  }

  initialize() {
    // Only active on web platform
    if (Capacitor.getPlatform() !== 'web') {
      debugLog('[AnalyticsService] Skipped — native platform');
      return;
    }
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (!measurementId) {
      debugLog('[AnalyticsService] No GA4 Measurement ID configured');
      return;
    }
    try {
      import('react-ga4').then((ReactGA) => {
        ReactGA.default.initialize(measurementId);
        this.initialized = true;
        debugLog('[AnalyticsService] GA4 initialized');
      });
    } catch (err) {
      console.error('[AnalyticsService] Init error:', err);
    }
  }

  trackPage(path) {
    if (!this.initialized) return;
    import('react-ga4').then((ReactGA) => {
      ReactGA.default.send({ hitType: 'pageview', page: path });
    });
  }

  trackEvent(category, action, label) {
    if (!this.initialized) return;
    import('react-ga4').then((ReactGA) => {
      ReactGA.default.event({ category, action, label });
    });
  }
}

export default new AnalyticsService();
